import React from 'react';
import { MdInfoOutline } from 'react-icons/md';
import { getSourceLabel } from 'Utils';
import DiscoveryTooltip from 'DiscoveryTooltip';

export function isAdoptedFromIntegration(connection) {
  return !!connection && !!connection.registeredServiceId;
}

const AdoptedFromBadge = ({ registeredServiceId, registeredServiceName, className }) => {
  if (!registeredServiceId) return null;
  // Prefer the integration's display name (server-resolved); the id heuristic is last resort.
  const label = registeredServiceName || getSourceLabel(registeredServiceId);
  return (
    <DiscoveryTooltip placement='top' text={`Imported from ${label}`}>
      <MdInfoOutline
        data-testid="imported-from-badge"
        className={className || 'ml-1'}
        style={{ color: '#5C6473', fontSize: '0.95em', verticalAlign: 'middle' }}
      />
    </DiscoveryTooltip>
  );
};

export default AdoptedFromBadge;
